<template>
  <div class="home">
    <Carousel>
      <!-- Slides with img slot -->
      <!-- Note the classes .d-block and .img-fluid to prevent browser default image alignment -->
      <router-link to="/infection-feast" >
        <b-carousel-slide class="carousel-responsive" >
          <img
            slot="img"
            class="carousel-img-responsive"
            src="../assets/SC_Map/Infection_Feast/cover.jpg"
            alt="image slot"
          />
          <h1>这是我们最受欢迎的地图</h1>
          <h5>充满了绝望的都市 & 经久不衰的感染机制</h5>
        </b-carousel-slide>
      </router-link>

    </Carousel>

    <HomePageCard>
    </HomePageCard>

    <b-row no-gutters>

      <b-col sm="6" lg="3" >
        <router-link to="infection-feast" >
          <div class="card-container">
            <div class="card-content">
              <div class="img-container">
                <img src="../assets/SC_Map/Infection_Feast.png">
              </div>
            </div>
          </div>
        </router-link>
      </b-col>
      <b-col sm="6" lg="3" >
        <router-link to="infection-outbreak-beta" >
          <div class="card-container">
            <div class="card-content">
              <div class="img-container">
                <img src="../assets/SC_Map/Infection_Outbreak_Beta.jpg">
              </div>
            </div>
          </div>
        </router-link>
      </b-col>
      <b-col sm="6" lg="3" >
        <router-link to="infection-outbreak-alpha" >
          <div class="card-container">
            <div class="card-content">
              <div class="img-container">
                <img src="../assets/SC_Map/Infection_Outbreak_Alpha.jpg">
              </div>
            </div>
          </div>
        </router-link>
      </b-col>
      <b-col sm="6" lg="3" >
        <router-link to="god-is-dead" >
          <div class="card-container">
            <div class="card-content">
              <div class="img-container">
                <img src="../assets/SC_Map/God_is_Dead.jpg">
              </div>
            </div>
          </div>
        </router-link>
      </b-col>

    </b-row>
    
  </div>
</template>

<script>
  // @ is an alias to /src
  import Carousel from '@/components/Carousel.vue'
  import HomePageCard from '@/components/HomePageCard.vue'
  export default {
    name: 'home',
    components: {
      Carousel,
      HomePageCard
    },
    props: {
      sticky: true,
    }
  }
</script>

<style lang="stylus" scoped>
    @import '~@/components/Carousel.styl'
</style>